import * as React from 'react';
import OverlayLoading from 'components/OverlayLoading';

import './styles/IframePreview.scss';

type Props = {
  height: number;
  src: string;
  title: string;
};

type State = {
  loading: boolean;
};

/**
 * Displays a [OverlayLoading](/internal/components/OverlayLoading) on mount & on src change.
 *
 * ```example
 *  <IframePreview src="http://ducksarethebest.com/" height={400} />
 * ```
 */
class IframePreview extends React.Component<Props, State> {
  state: State = {
    loading: true,
  };

  componentWillReceiveProps = (nextProps: Props) => {
    if (this.props.src !== nextProps.src) {
      this.setState({ loading: true });
    }
  };
  onLoad = () => this.setState({ loading: false });

  render() {
    const { height, src, title } = this.props;

    return (
      <div style={{ height: height + 5 }} className="IframePreview">
        {this.state.loading && <OverlayLoading />}
        <iframe
          src={src}
          style={{ height }}
          title={title}
          className="IframePreview-iframe"
          onLoad={this.onLoad}
        />
      </div>
    );
  }
}

export default IframePreview;
